import {useEffect, useState} from 'react';
import {useDeviceSelectors} from 'react-device-detect';

type DeviceSelectors = {
  isChrome: boolean;
  isEdge: boolean;
  isOpera: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isWindows: boolean;
  engineName: string;
  osName: string;
  osVersion: string;
};

const CHROMIUM_BRANDS = new Set(['Google Chrome', 'Microsoft Edge', 'Opera']);
export function useUserAgent() {
  const [selectors]: [DeviceSelectors] = useDeviceSelectors(window.navigator.userAgent);
  const [isAvailableWindows, setIsAvailableWindows] = useState<boolean>();

  const isAvailableBrowser = window.navigator.userAgentData?.brands.some((brand) =>
    CHROMIUM_BRANDS.has(brand.brand),
  );

  const isDesktop = !selectors.isMobile && !selectors.isTablet;

  useEffect(() => {
    //? Дополнительная проверка для Firefox проверка ОС
    setIsAvailableWindows(selectors.isWindows && parseFloat(selectors.osVersion) >= 10);

    window.navigator.userAgentData?.getHighEntropyValues(['platformVersion']).then((ua) => {
      if (ua.platform !== 'Windows') {
        setIsAvailableWindows(false);
        return;
      }
      // Из-за особенностей маппинга UA-CH:
      // "1.0.0" — "3.0.0" соответствует Windows 7 / 8 / 8.1
      // "10.0.0+" соответствует Windows 10 / 11
      const majorVersion = parseInt(ua.platformVersion.split('.')[0]);

      if (majorVersion >= 10) {
        setIsAvailableWindows(true);
        return;
      }
      setIsAvailableWindows(false);
    });
  }, [selectors.isWindows, selectors.osVersion]);

  return {isAvailableBrowser, isDesktop, isAvailableWindows};
}
